import { makeAutoObservable } from "mobx";
import { isModuleIdResponseDTO } from "./ModuleId";
import {
  isModuleResourceResponseDTO,
  isModuleResourceWithSomeTaskInfoResponseDTO,
  ModuleResourceResponseApi,
} from "./ModuleResource";

export interface ModuleResponseApi {
  moduleId: string;
  moduleName: string;
}

export class ObservableModulePropImpl implements ModuleResponseApi {
  moduleId: string;
  moduleName: string;

  constructor(module: ModuleResponseApi) {
    this.moduleId = module.moduleId;
    this.moduleName = module.moduleName;
    makeAutoObservable(this);
  }

  onChangeId = (moduleId: string) => {
    this.moduleId = moduleId;
  };

  onChangeName = (moduleName: string) => {
    this.moduleName = moduleName;
  };
}

export class EmptyModulePropImpl implements ModuleResponseApi {
  moduleId: string = "";
  moduleName: string = "";
}

export let isModuleResponseDTO = (
  variable: unknown
): variable is ModuleResponseApi => {
  return (
    isModuleIdResponseDTO(variable) &&
    "moduleName" in variable &&
    typeof variable.moduleName === "string"
  );
};

export interface ModuleWithResourcesAndTasksResponseApi
  extends ModuleResponseApi {
  moduleResources: ModuleResourceResponseApi[];
}

export let isModuleWithResourcesResponseDTO = (
  variable: unknown
): variable is ModuleWithResourcesAndTasksResponseApi => {
  return (
    isModuleResponseDTO(variable) &&
    "moduleResources" in variable &&
    Array.isArray(variable.moduleResources) &&
    variable.moduleResources.reduce(
      (doArrayConsistOfResources, moduleResource: unknown) =>
        doArrayConsistOfResources &&
        isModuleResourceResponseDTO(moduleResource),
      true
    )
  );
};

export let isModuleWithResourcesWithSomeTaskInfoResponseDTO = (
  variable: unknown
): variable is ModuleWithResourcesAndTasksResponseApi => {
  return (
    isModuleResponseDTO(variable) &&
    "moduleResources" in variable &&
    Array.isArray(variable.moduleResources) &&
    variable.moduleResources.reduce(
      (doArrayConsistOfResources, moduleResource: unknown) =>
        doArrayConsistOfResources &&
        isModuleResourceWithSomeTaskInfoResponseDTO(moduleResource),
      true
    )
  );
};

export class ModuleWithResourcesAndTasksResponseImpl
  implements ModuleWithResourcesAndTasksResponseApi
{
  moduleResources: ModuleResourceResponseApi[];
  moduleId: string;
  moduleName: string;

  constructor(module: ModuleWithResourcesAndTasksResponseApi) {
    this.moduleResources = module.moduleResources;
    this.moduleId = module.moduleId;
    this.moduleName = module.moduleName;
  }
}

export class EmptyModuleWithResourcesAndTasksImpl
  implements ModuleWithResourcesAndTasksResponseApi
{
  moduleId: string = "";
  moduleName: string = "";
  moduleResources: ModuleResourceResponseApi[] = [];
}
